exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-09a94b36] {\n    position: absolute;\n    z-index: 1000;\n    /*width: 100%;*/\n}\nli[data-v-09a94b36] {\n    cursor: pointer;\n    color: white;\n}\nli[data-v-09a94b36]:hover {\n    background-color: #f4f4f4;\n}\n", ""]);

// exports
